import React, { useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import { Navigation, Pagination, Autoplay, EffectCoverflow } from "swiper/modules";
import "bootstrap/dist/css/bootstrap.min.css";
import '../userHeader/UserHeader.scss';
import { FaSearch } from "react-icons/fa";
import { FaLocationArrow } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa";
// import { X } from "lucide-react";
import bgImage1 from "../Assests/b7680b2dcdce1d759b4769a970329d7e 1.png"; // Import correctly
import bgImage2 from "../Assests/mountain_tourist_2.jpg";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";


function BgFirstContainer() {
    const [activeTab, setActiveTab] = useState("Hourly");
    const [active, setActive] = useState("first");
    const [show, setShow] = useState(false);

    const stops = [
        { id: 1, address: "3820 N Braeswood Blvd", country: "United States" },
        { id: 2, address: "3910 N Braeswood Blvd", country: "United States" },
    ];
    return (
        <div className="firstContainer" style={{zIndex:50}}>
        <div className="position-relative w-100 vh-90 " style={{zIndex:30}}>
            {/* Background Image Slider */}
            <Swiper
                modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
                effect="slide"
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                speed={1000}
                navigation={true}
                pagination={{ clickable: true }}
                loop={true}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={1}
                className="position-absolute top-0 start-0 w-100 box-height1"
                style={{ height: "75vh", zIndex: "-1" }}
            >
                <SwiperSlide className="slide">
                    <div className="image-container">
                        <img src={bgImage1} alt="Slide 1" className="dark-image" />
                    </div>
                </SwiperSlide>
                <SwiperSlide className="slide">
                    <div className="image-container">
                        <img src={bgImage2} alt="Slide 2" className="dark-image" />
                    </div>
                </SwiperSlide>
            </Swiper>

            {/* ✅ Main Content Wrapper (Ensures Content is Above Background) */}
            <div className="box-height container position-relative text-white p-0 d-flex flex-column align-items-cener justify-content-center "
            >
                <div className="container-fluid mt-5 ">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12 ">

                            <h1 className="display-5  find-text">
                                Find your ideal <span className="text-success">Party Bus</span>
                            </h1>
                            <h1 className="m-0 display-5   find-text">
                                For the best price
                            </h1>
                            <p>Introducing the most efficent way to hire private trasportation.</p>
                            {/* Search Input */}
                            <div className="mt-4 bg-white d-flex align-items-center rounded-pill shadow-lg p-2 m-0 px-4 w-100" style={{ maxWidth: "400px" }}>
                                <input
                                    type="text"
                                    placeholder="What Vehicle are you looking for?"
                                    className="form-control border-0  shadow-none"
                                />
                            </div>
                        </div>
                    </div>
                </div>


                {/* ✅ White Box for Booking Options */}
                <div className="container-fluid mt-5 d-md-block d-none">
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-12 p-0">
                            <div className=" text-dark  rounded-4 shadow-lg py-4 position-relative">
                                <div className="position-absolute top-0 start-0 w-40 d-flex">
                                    {["Hourly", "One Way", "Multi-Day"].map((tab) => (
                                        <button
                                            key={tab}
                                            className={`custom-tab-btn flex-fill btn ${activeTab === tab ? "btn-success text-white fw-bold" : "text-dark bg-light"}`}
                                            onClick={() => setActiveTab(tab)}>
                                            {tab}
                                        </button>
                                    ))}
                                </div>

                                <div className="bg-white px-2">

                                    <div className="d-flex  align-items-baseline passenger-info-box" >
                                        {/* Passenger Selection */}
                                        <select className="form-select w-auto border-0 bg-light text-dark fw-semibold mt-3">
                                            <option>1-4 Passengers</option>
                                            <option>5-10 Passengers</option>
                                            <option>11-24 Passengers</option>
                                        </select>
                                        <p className="ps-3 m-0" style={{ fontSize: "12px" }}> RETURN TO:</p>
                                        <div className="toggle-container">
                                            <div className={`slider ${active === "second" ? "move-right" : ""}`}></div>

                                            <button
                                                className={`toggle-btn ${active === "first" ? "active" : ""}`}
                                                onClick={() => setActive("first")} style={{ fontSize: "13px" }}
                                            >
                                                Return to the same location
                                            </button>

                                            <button
                                                className={`toggle-btn ${active === "second" ? "active" : ""}`}
                                                onClick={() => setActive("second")} style={{ fontSize: "13px" }}
                                            >
                                                Return to the other location
                                            </button>
                                        </div>
                                    </div>

                                    {/* ✅ Dynamic Page Content Based on Active Tab */}
                                    <div className="tab-content mt-3">
                                        {activeTab === "Hourly" && (
                                            <div>
                                                <div className="row  bg-light rounded-3 py-3 px-2 mx-2 ">
                                                    <div className="d-flex align-items-center">

                                                        <div className="col-md-4 d-flex  px-3 align-items-center  home-box-content">
                                                            <div className="">

                                                                <FaLocationArrow className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt">Pickup location</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Midtown, Houston, TX..</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt">United States</small>
                                                            </div>
                                                        </div>

                                                        <div className=" text-center ">
                                                            <button className="btn btn-sm btn-success rounded-pill px-3"> Stops</button>
                                                        </div>

                                                        <div className="col-md-4 d-flex  px-3 align-items-center justify-content-center home-box-content1">
                                                            <div className="">
                                                                <FaLocationArrow className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt">Pickup location</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Midtown, Houston, TX..</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt">United States</small>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 d-flex  ps-3 align-items-center ">
                                                            <div className="">

                                                                <FaRegClock className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt1 d-flex">Pickup &nbsp; <span className="d-lg-block d-none"> & Drop </span>off time</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Sun, Dec 23</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt1 d-flex">6:30am - 5:00pm &nbsp; <span className="d-lg-block d-none" >(6H 30M)</span></small>
                                                            </div>

                                                        </div>
                                                        <div className="search-box d-flex d-xl-block d-none">
                                                            <FaSearch className="h4 m-0" />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === "One Way" && (
                                            <div>
                                                <div className="row  bg-light rounded-3 py-3 px-2 mx-2 ">
                                                    <div className="d-flex align-items-center">

                                                        <div className="col-md-4 d-flex  px-3 align-items-center  home-box-content">
                                                            <div className="">

                                                                <FaLocationArrow className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt">Pickup location</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Midtown, Houston, TX..</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt">United States</small>
                                                            </div>
                                                        </div>

                                                        <div className="text-center">
                                                            {/* Stops Button */}
                                                            <Button variant="success" size="sm" className="rounded-pill px-3" onClick={() => setShow(true)}>
                                                                Stops
                                                            </Button>

                                                            {/* Popup Modal */}
                                                            <Modal show={show} onHide={() => setShow(false)} centered>
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Stops</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <Container>
                                                                        {/* Stops List */}
                                                                        {stops.map((stop) => (
                                                                            <Row key={stop.id} className="align-items-center py-2 border-bottom">
                                                                                <Col xs={9}>
                                                                                    <p className="mb-0 fw-semibold">{stop.address}</p>
                                                                                    <p className="mb-0 text-muted small">{stop.country}</p>
                                                                                </Col>
                                                                                <Col xs={3} className="text-end">
                                                                                    <Button variant="light" className="text-danger rounded-circle p-1">
                                                                                        ❌
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>
                                                                        ))}
                                                                        {/* Add Stop Section */}
                                                                        <Row className="mt-3 text-muted text-center">
                                                                            <Col>
                                                                                <span className="fs-5">🔍</span>
                                                                                <span className="ms-2">Add your stop location</span>
                                                                            </Col>
                                                                        </Row>
                                                                    </Container>
                                                                </Modal.Body>
                                                            </Modal>
                                                        </div>



                                                        <div className="col-md-4 d-flex  px-3 align-items-center justify-content-center home-box-content1">
                                                            <div className="">
                                                                <FaLocationArrow className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt">Pickup location</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Midtown, Houston, TX..</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt">United States</small>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 d-flex  ps-3 align-items-center ">
                                                            <div className="">

                                                                <FaRegClock className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt1 d-flex">Pickup &nbsp; <span className="d-lg-block d-none"> & Drop </span>off time</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Sun, Dec 23</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt1 d-flex">6:30am - 5:00pm &nbsp; <span className="d-lg-block d-none" >(6H 30M)</span></small>
                                                            </div>

                                                        </div>
                                                        <div className="search-box d-flex d-xl-block d-none">
                                                            <FaSearch className="h4 m-0" />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === "Multi-Day" && (
                                            <div>
                                                <div className="row  bg-light rounded-3 py-3 px-2 mx-2 ">
                                                    <div className="d-flex align-items-center">

                                                        <div className="col-md-4 d-flex  px-3 align-items-center  home-box-content">
                                                            <div className="">

                                                                <FaLocationArrow className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt">Pickup location</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Midtown, Houston, TX..</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt">United States</small>
                                                            </div>
                                                        </div>

                                                        <div className="text-center">
                                                            {/* Stops Button */}
                                                            <Button variant="success" size="sm" className="rounded-pill px-3" onClick={() => setShow(true)}>
                                                                Stops
                                                            </Button>

                                                            {/* Popup Modal */}
                                                            <Modal show={show} onHide={() => setShow(false)} centered>
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Stops</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <Container>
                                                                        {/* Stops List */}
                                                                        {stops.map((stop) => (
                                                                            <Row key={stop.id} className="align-items-center py-2 border-bottom">
                                                                                <Col xs={9}>
                                                                                    <p className="mb-0 fw-semibold">{stop.address}</p>
                                                                                    <p className="mb-0 text-muted small">{stop.country}</p>
                                                                                </Col>
                                                                                <Col xs={3} className="text-end">
                                                                                    <Button variant="light" className="text-danger rounded-circle p-1">
                                                                                        ❌
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>
                                                                        ))}
                                                                        {/* Add Stop Section */}
                                                                        <Row className="mt-3 text-muted text-center">
                                                                            <Col>
                                                                                <span className="fs-5">🔍</span>
                                                                                <span className="ms-2">Add your stop location</span>
                                                                            </Col>
                                                                        </Row>
                                                                    </Container>
                                                                </Modal.Body>
                                                            </Modal>
                                                        </div>



                                                        <div className="col-md-4 d-flex  px-3 align-items-center justify-content-center home-box-content1">
                                                            <div className="">
                                                                <FaLocationArrow className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt">Pickup location</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Midtown, Houston, TX..</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt">United States</small>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 d-flex  ps-3 align-items-center ">
                                                            <div className="">

                                                                <FaRegClock className="h4 me-2 m-0 text-success" />
                                                            </div>
                                                            <div className="">
                                                                <small className="text-muted pickup-txt1 d-flex">Pickup &nbsp; <span className="d-lg-block d-none"> & Drop </span>off time</small>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="fw-bold midtown-tst">Sun, Dec 23</span>
                                                                </div>
                                                                <small className="text-muted pickup-txt1 d-flex">6:30am - 5:00pm &nbsp; <span className="d-lg-block d-none" >(6H 30M)</span></small>
                                                            </div>

                                                        </div>
                                                        <div className="search-box d-flex d-xl-block d-none">
                                                            <FaSearch className="h4 m-0" />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </div>
    )
}
export default BgFirstContainer